// Refactor 02/2026 — extrahiert aus AppointmentsPage.js (Monats-Ansicht).
import React from 'react';
import { toLocalYMD } from './calendarUtils';

export const MonthView = ({
  currentDate,
  setCurrentDate,
  setView,
  daysInMonth,
  appointmentsByDateString,
}) => (
  <div className="p-4">
    <div className="grid grid-cols-7 gap-2">
      {['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map((day) => (
        <div
          key={day}
          className="text-center font-semibold text-sm py-2 bg-gray-100 rounded"
        >
          {day}
        </div>
      ))}
      {daysInMonth.map((day) => {
        const isCurrentMonth = day.getMonth() === currentDate.getMonth();
        const isToday = day.toDateString() === new Date().toDateString();
        const dayAppointments =
          appointmentsByDateString[day.toDateString()] || [];

        return (
          <div
            key={day.toISOString()}
            data-testid={`month-day-${toLocalYMD(day)}`}
            className={`min-h-[100px] p-2 border rounded cursor-pointer hover:bg-gray-50 ${
              !isCurrentMonth ? 'bg-gray-50 text-gray-400' : ''
            } ${isToday ? 'border-teal-500 border-2' : ''}`}
            onClick={() => {
              setCurrentDate(day);
              setView('day');
            }}
          >
            <div
              className={`text-sm font-medium ${
                isToday ? 'text-teal-600' : ''
              }`}
            >
              {day.getDate()}
            </div>
            {dayAppointments.length > 0 && (
              <div className="mt-1 text-xs text-gray-600">
                {dayAppointments.length} Termin
                {dayAppointments.length > 1 ? 'e' : ''}
              </div>
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default MonthView;
